import {ADMIN_SET_USER} from './actionTypes'

export const adminSetUser = (id) => ({
    type: ADMIN_SET_USER,
    payload: {
        id,
    }
});